import { IActTeamMemberAvailableList } from '~/services/api/actTeamMember/types';
import { IUserRole } from '~/types';
import compareRoles from '../compareRoles';

const excludeGlobalUsers = (items: IActTeamMemberAvailableList[]): IActTeamMemberAvailableList[] =>
  (items || []).filter(
    item => !(item.roles?.length === 1 && compareRoles(IUserRole.GlobalUser, item.roles[0].name)),
  );

export default excludeGlobalUsers;
